module.exports = __webpack_public_path__ + "static/ymca-logo-fc51c9875fda3690ca997a11d7ab7be3.svg";